// ---------------------------------------------------------------------------------------------------------------------

/**
 * Default error class for Alepha.
 */
export class AlephaError extends Error {
  name = "AlephaError";
}

// ---------------------------------------------------------------------------------------------------------------------
